import KendoPivotDataSourceMixin from './KendoPivotDataSourceMixin'

export default {
    name: 'kendo-pivotdatasource',
    mixins: [ KendoPivotDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/index.js